import React, { useEffect, useState } from "react";
import { postData } from "../../../services/api";
import { Tooltip } from "react-tooltip";

const FeaturesPlan = () => {
  const [planFeatures, setPlanFeatures] = useState([]);
  const [plans, setPlans] = useState([]);

  const convartString = (string) => {
    let wordsArray = string.split("-");
    let capitalizedWords = wordsArray.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
    let resultString = capitalizedWords.join(" ");
    return resultString;
  };

  useEffect(() => {
    const loadPlanFeatures = async () => {
      try {
        const result = await postData("plan-feature/list", {
          sortQuery: { ordering: 1 },
          status: 1,
        });
        if (result.data) {
          const groupedData = result.data.reduce((acc, item) => {
            const key = item.headingType || "no-heading-type";
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(item);
            return acc;
          }, {});

          // Convert the grouped data into an array if needed
          const results = Object.keys(groupedData).map((key) => ({
            headingType: key,
            items: groupedData[key],
          }));
          setPlanFeatures(results);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPlanFeatures();
    const loadPlans = async () => {
      try {
        const result = await postData("plans/list", {
          limit: 4,
          offset: 0,
          sortQuery: { ordering: 1 },
          isView: 1,
        });
        if (result.data) {
          setPlans(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPlans();
  }, []);
  return (
    <div className="relative z-10 w-full px-4 md:px-0 -mt-64 max-w-[1282px]  max-h-auto h-auto mx-auto bg-white border-8 border-[#DCECEC] rounded-[18px] p-4 md:p-6">
      <div className="w-full mt-4">
        <div className="flex w-full gap-4 items-center mx-auto px-6 ">
          <div className="relative w-full">
            {planFeatures &&
              planFeatures.length > 0 &&
              planFeatures
                .filter(
                  (_row) =>
                    _row.headingType !== "no-heading-type" &&
                    _row.headingType !== "number-of-plans"
                )
                .map((item, index) => {
                  return (
                    <table className="w-full text-sm text-left" key={index}>
                      <thead className="text-xs text-black uppercase bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="px-2 py-4 text-black font-Outfit text-[20px] whitespace-nowrap capitalize font-semibold text-center"
                          >
                            {convartString(item?.headingType)}
                          </th>
                          {plans.length > 0 &&
                            plans.map((_it, _idx) => {
                              return (
                                <th
                                  scope="col"
                                  className="px-2 py-4 text-black font-Outfit text-[20px] whitespace-nowrap capitalize font-semibold text-center"
                                  key={index + "-" + _idx}
                                >
                                  {_it?.name}
                                </th>
                              );
                            })}
                        </tr>
                      </thead>
                      <tbody>
                        {item.items?.length > 0 &&
                          item.items.map((it, ids) => {
                            let evenOdd = ids % 2 === 0 ? "even" : "odd";
                            return (
                              <>
                                <tr
                                  className={
                                    evenOdd === "even"
                                      ? "bg-[#F3FFF6]"
                                      : "bg-[#F0F2FF]"
                                  }
                                  key={ids}
                                >
                                  <td
                                    scope="row"
                                    className="px-6 py-3 text-black font-Outfit text-[16px] whitespace-nowrap capitalize text-center relative group p-3"
                                    data-tooltip-id={"info-tooltip-" + ids}
                                    data-tooltip-content={it?.short_description}
                                  >
                                    {it?.name}
                                    {
                                      it?.short_description && (
                                        <Tooltip
                                          id={"info-tooltip-" + ids}
                                          place="top"
                                          style={{
                                            maxWidth: "400px",
                                            wordBreak: "break-word",
                                            overflowWrap: "break-word",
                                            whiteSpace: "normal",
                                            padding: "5px",
                                            backgroundColor: "#333",
                                            color: "#fff",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      )
                                      // <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block px-2 py-1 bg-gray-700 text-white text-xs rounded tooltip">{it?.short_description}</span>
                                    }
                                  </td>
                                  {plans.length > 0 &&
                                    plans.map((_it, _idx) => {
                                      let featureRow = _it?.features?.filter(
                                        (val) => val?.code === it?.code
                                      );
                                      if (featureRow && featureRow.length > 0) {
                                        if (
                                          featureRow[0]?.fieldType &&
                                          featureRow[0]?.fieldType ===
                                            "checkbox" &&
                                          featureRow[0]?.checkboxValue
                                        ) {
                                          return (
                                            <td
                                              scope="row"
                                              className="px-6 py-3 text-teal-500 font-PlusJakartaSans text-lg whitespace-nowrap capitalize text-center relative group"
                                              key={_idx}
                                            >
                                              <i className="fa-solid fa-circle-check"></i>
                                            </td>
                                          );
                                        } else {
                                          return (
                                            <td
                                              scope="row"
                                              className="px-6 py-3 text-teal-500 font-PlusJakartaSans text-lg whitespace-nowrap capitalize text-center relative group"
                                              key={_idx}
                                            ></td>
                                          );
                                        }
                                      }
                                    })}
                                </tr>
                                <tr className={"bg-transparent"}>
                                  <td>&nbsp;</td>
                                </tr>
                              </>
                            );
                          })}
                      </tbody>
                    </table>
                  );
                })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPlan;
